
export const mapPercent = data => {
  const totalCount = data.reduce((acc, current) => {
    acc += current.count;
    return acc;
  }, 0);
  data.forEach(d => {
    d.percent = Number(d.count / totalCount * 100).toFixed(1);
  })
};